// import { catalogoApi } from '../services/api';

import { toast } from 'react-toastify';
import { uploadFileApi } from '../services/api';
import { ResponseAPI } from './responseApi';
import { RuleValidationCheckup, RuleValidationResponse, RuleValidationResponseData } from '../models/RuleValidator';
import { AxiosError } from 'axios';

type RequestForUploadProps = {
  document: string;
  documentType: string;
};

type ResponseRequestForUploadProps = {
  id: number;
  patientId: number;
  sent: number;
  createdAt: string;
  updatedAt: string;
};

export const createRequestForUpload = async ({ document, documentType }: RequestForUploadProps) => {
  const result: ResponseAPI<ResponseRequestForUploadProps> = {
    error: false,
    errorStatus: null,
    message: '',
    data: {} as ResponseRequestForUploadProps
  };
  try {
    const response = await uploadFileApi.post('requests', {
      document,
      documentType
    });
    result.data = response.data;

    return result;
  } catch (e) {
    const error = e as AxiosError;
    result.error = true;
    console.error(error);
    return result;
  }
};

export const uploadFiles = async ({ files, requestId }: { files: Blob[]; requestId: number }) => {
  const result: ResponseAPI<string> = {
    error: false,
    errorStatus: null,
    message: '',
    data: ''
  };

  const formData = new FormData();
  files.map(file => formData.append('files', file));

  formData.append('requestId', String(requestId));

  try {
    const response = await uploadFileApi.post('files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });

    result.data = response?.data?.message || '';

    return result;
  } catch (e) {
    const error = e as AxiosError;
    result.error = true;
    console.error(error);
    toast.error('Erro no upload de arquivos');
    return result;
  }
};
